import { Injectable } from '@angular/core';
import { ReplaySubject } from 'rxjs/ReplaySubject';

@Injectable()
export class OomphService {

  // State variable as Observers
  private currentViewSubject = new ReplaySubject<string>(1);
  public currentView = this.currentViewSubject.asObservable();
 
  // views
  public view_oom_dashboard:string = 'view_oom_dashboard';
  public view_oom_payments:string = 'view_oom_payments';
  public view_oom_chat:string = 'view_oom_chat';


  setCurrentView(view) {
    this.currentViewSubject.next(view);
  }
}



// WEBPACK FOOTER //
// C:/Azure/Source/Workspaces/SalesNOW/SalesSOLO/WebSites/SalesSOLO.Web.Angular.telesales/src/app/services/oomph/oomph.service.ts